var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1997 4.63281C26.2366 4.66969 26.3121 4.7663 26.3921 4.97949C26.4729 5.19507 26.5004 5.36593 26.5005 5.49902V5.92676L24.7046 13.0264L24.311 14.583H35.0005C35.5361 14.5831 36.0018 14.7689 36.4497 15.2168C36.8976 15.6648 37.0835 16.1304 37.0835 16.666V19.999C37.0835 20.1048 37.0721 20.2356 37.0425 20.3936C37.0165 20.5319 36.979 20.6521 36.9341 20.7568L36.9331 20.7598L31.938 32.4971C31.7974 32.8038 31.5532 33.1006 31.1401 33.376C30.7414 33.6418 30.3686 33.749 30.0005 33.749H14.5835V13.8506L25.0005 3.43359L26.1997 4.63281ZM8.75049 14.583V33.749H4.5835V14.583H8.75049Z",
    fill: "#DFE3E8",
    stroke: "#DFE3E8",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/Like.681e7cef2f27d9c1569f6e048acce1ca.svg";
export { ForwardRef as ReactComponent };